// components/CroppedAvatar.jsx
import React from "react";

const CroppedAvatar = ({
  avatarUrl,
  avatarCrop = { zoom: 1, offsetX: 0, offsetY: 0 },
  size = 128,
  className = "",
}) => {
  const { zoom = 1, offsetX = 0, offsetY = 0 } = avatarCrop;

  const transform = `scale(${zoom}) translate(${offsetX * 100}%, ${offsetY * 100}%)`;

  return (
    <div
      className={`relative overflow-hidden rounded-full flex-shrink-0 ${className}`}
      style={{ width: size, height: size }}
    >
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt="Profile"
          className="absolute inset-0 w-full h-full object-cover"
          style={{
            transform,
            transformOrigin: "center center",
          }}
        />
      ) : (
        <div className="w-full h-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
          <span className="text-gray-400 text-4xl">👤</span>
        </div>
      )}
    </div>
  );
};

export default CroppedAvatar;
